import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

export const getNearestStores = async (params: INearestParams) => {
  const data: {data: INearestStores} = await request.get(
    `api/v2/store/nearest-stores`,
    {
      params: params,
    } as AxiosRequestConfig,
  );

  return data;
};
